import { render } from "./Ranking.vue?vue&type=template&id=626605b2&scoped=true&ts=true"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=626605b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626605b2"]])

export default __exports__